/*
 * 左侧菜单栏- 使用antd
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-16 16:53:56
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2020-05-20 14:36:55
 */

import * as React from 'react';
import { Layout, Menu, Modal } from 'antd';
import PropsTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import HeaderLogo from './HeaderLogo';
import SideMenuItem from './MenuItem';
import extendBtn from 'images/extend_btn.png';
import reduceBtn from 'images/reduce_btn.png';
import './index.less';

const Sider = Layout.Sider;

const prefixCls = 'biz-side-menu2-component';

@withRouter
export default class SideMenu extends React.Component {
	state = {
		activeKey: '',
	};

	componentDidMount () {
		const { location } = this.props;
		this.computeActiveMenu(location);
	}

	componentWillReceiveProps (nextProps) {
		const { location } = nextProps;
		const { location: prevLocation } = this.props;

		if (prevLocation.pathname !== location.pathname) {
			// location变更了，需要重新计算当前选中的菜单的key
			this.computeActiveMenu(location);
		}
	}

	// 菜单栏被点击
	handleMenuItemClick = (values) => {
		const { history } = this.props;
		const { key } = values;
		const { activeKey } = this.state;
		if (activeKey === 'cookbook-manage' && key !== 'cookbook-manage') {
			//从周菜谱跳出去先提示是否确认发布
			return Modal.confirm({
				title: '你即将离开周菜谱模块',
				content: '周菜谱中的修改若未点击发布将会丢失，是否离开',
				onOk: () => history.push(`/${key}`),
			});
		}
		history.push(`/${key}`);
	}

	// 从URL中计算出当前选中的menu
	computeActiveMenu = (location) => {
		const dataTypeList = location.pathname.split('/').filter(i => i); // 过滤掉“”
		if (dataTypeList && dataTypeList.length) {
			const dataType = dataTypeList[0];
			this.setState({ activeKey: dataType });
		}
	}

	render () {
		const { menus, logo, onMenusTroggleClick, isOpen } = this.props;
		const { activeKey } = this.state;
		const selectedKeys = [activeKey];

		return (
			<div className={prefixCls}>
				<Sider
				  collapsible
					trigger={null}
					width={164}
					collapsedWidth={82}
					style={{ background: '#18203F' }}
					className={`${prefixCls}-content`}
					collapsed={!isOpen}
				>
			    <HeaderLogo url={logo} isOpen={isOpen} />
					<Menu
						theme="dark"
						style={{ background: '#18203F' }}
						mode="inline"
						onClick={this.handleMenuItemClick}
						selectedKeys={selectedKeys}
					>
					  {menus.map(item => (
							<SideMenuItem
								key={item.dataType}
								menu={item}
							/>
						))}
					</Menu>
					<span className={`${prefixCls}-collapse-btn`} onClick={onMenusTroggleClick}>
						<img src={isOpen ? reduceBtn : extendBtn} alt=''/>
					</span>
				</Sider>
			</div>
		);
	}
}

SideMenu.propTypes = {
	menus: PropsTypes.array.isRequired,  // 菜单
	logo: PropsTypes.string,
	isOpen: PropsTypes.bool,             // 是否展开
	onMenusTroggleClick: PropsTypes.func, // 点击打开或关闭菜单栏按钮
};
